import { CommitmentLayout as CciLayoutComponent } from '../../../components/Commitment';

export function CommitmentLayout() {
  return <CciLayoutComponent />;
}
